<template>
  <div class="container">
    <div class="searchbox">
      <b-form-input
        :id="id+'-targetableDiv'"
        type="text"
        :class="id+'targetableDiv ' + (selection != null && selection.value !== null ? 'greenBorder' : (invalid ? 'redBorder' : ''))"
        v-model="query"
        :placeholder="placeholder"
        @focusin="focusIn"
        :required="required"
      />
    </div>
    <div class="invalid-message mt-1" v-if="invalid">
      <p>{{invalidMessage}}</p>
    </div>
    <div class="results" v-if="listOpen">
      <ul class="">
        <li v-for="result in results" @click="onClick(result)" class="targetableDiv">
          <span>{{ result.text }}</span>
        </li>
      </ul>
    </div>
  </div>

</template>

<script>
export default {
  name: "AutoCompleteInput",

  props: {
    id:{
      type: String
    },
    options: {
      type: Array,
      required: true
    },
    placeholder: {
      type: String
    },
    initValue: {
      type: Object
    },
    required: {
      type: Boolean
    },
    invalid: {
      type: Boolean
    },
    invalidMessage: {
      type: String
    }
  },

  data() {
    return {
      query: '',
      results: [],
      selection: {value: null, text: null},
      listOpen: false,
    }
  },

  mounted() {
    //This listener is here as hidding the list with focusOut on input prevents the click on a list element to be triggered
    //But we still need to hide the list when user clicks elsewhere on the screen
    document.addEventListener('click', this.clickAnyWhere)

    //For modal
    this.results = this.$props.options
  },

  beforeDestroy() {
    document.removeEventListener('click', this.clickAnyWhere)
  },

  watch: {
    query: function() {
      //We don't want to trigger search when we click on an option
      // but we do when we erase the text from the selected option
      if(this.query !== this.selection.text) this.search();
    },
    "selection.value": function(){
      this.$emit('didSelect', this.selection.value)
    },
    "options": function(value){
      this.results = value
      this.setInitValue(this.$props.initValue.value)
    },
    'initValue.value': function(value){
      this.setInitValue(value)
    },
  },

  // METHODS
  methods: {

    focusIn(){
      this.listOpen = true
    },

    setInitValue(value){
      if(value !== null && value !== undefined){
        this.selection = this.results.find(it => it.value === value)
        this.query = this.selection.text
      }
    },

    resetSelection(){
      this.selection = {value: null, text: null}
      this.$emit('onReset')
    },

    search: _.debounce(
      function() {
        this.resetSelection()
        if(this.query.length > 0){
          this.results = this.$props.options.filter(it => it.text.toLowerCase().includes(this.query.toLowerCase()))
        }else{
          this.results = this.$props.options
        }
      }, 250
    ),

    onClick(result) {
      this.query = result.text
      this.selection = result
      this.listOpen = false
    },

    clickAnyWhere(event){
      //We listen to every click and check if its an element from this component
      let className = event.target.className.toString()
      if(!(className.includes(this.$props.id+"targetableDiv"))){
        this.listOpen = false
      }
    }
  }
}
</script>

<style scoped>
.container{
  position: relative;
  padding: 0;
}

.searchbox input {
  width: 100%;
  height: 38px;
  border-radius: 5px;
  padding: 6px 12px;
  border: 1px solid var(--neutral-300);
}

.invalid-message{
  font-size: 0.8em;
  color: var(--main-red);
}

.redBorder{
  border-color: var(--main-red) !important;
}

.greenBorder{
  border-color: var(--main-green) !important;
}

.results {
  width: 100%;
  max-height: 200px;
  position: absolute;
  border: 1px solid var(--neutral-300);
  background-color: var(--main-white);
  z-index: 2;
  overflow-y: scroll;
}

.results ul {
  width: 100%;
  padding: 4px;
}
.results li {
  padding: 0 5px;
  list-style: none;
}
.results li:hover {
  background-color: var(--surface-secondary);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/AutoCompleteInput.vue